import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaAndroid } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-[calc(100dvh-8rem)] flex flex-col items-center justify-center px-4 relative overflow-hidden bg-white dark:bg-purple-950 pt-16">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover pointer-events-none opacity-20 dark:opacity-40"
      >
        <source src="/weaver-bg.mp4" type="video/mp4" />
      </video>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/20 rounded-full blur-[128px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-amber-600/10 rounded-full blur-[128px] pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="text-center max-w-4xl z-10"
      >
        <div className="flex justify-center mb-8">
          <div className="p-5 bg-white dark:bg-purple-900 rounded-3xl border border-gray-200 dark:border-purple-800 shadow-2xl">
            <SafeIcon icon={FiIcons.FiFeather} className="text-6xl text-amber-600 dark:text-amber-500" />
          </div>
        </div>
        <h1 className="text-6xl md:text-8xl font-serif font-bold mb-8 tracking-tighter text-gray-900 dark:text-white leading-tight">
          Forge Your World.<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-amber-500 to-amber-400">
            Live Your Story.
          </span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-900 dark:text-purple-300 mb-12 max-w-2xl mx-auto leading-relaxed font-light">
          An immersive AI-powered collaborative storytelling suite for professional writers, literary enthusiasts, and roleplayers worldwide.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
          <button
            onClick={() => user ? navigate('/setup/quiz') : navigate('/auth')}
            className="btn-primary w-full sm:w-auto flex items-center justify-center space-x-3 text-xl px-10 py-5 hover:scale-105 transition-transform"
          >
            <span className="text-white font-black">Begin Your Journey</span>
            <SafeIcon icon={FiIcons.FiArrowRight} className="text-white" />
          </button>
          <button
            onClick={() => navigate('/story')}
            className="btn-secondary w-full sm:w-auto text-xl px-10 py-5 hover:scale-105 transition-transform font-black"
          >
            Resume Story
          </button>
        </div>

        <div className="mt-8">
          <a
            href="https://github.com/julieadamsconsulting/Weaver/releases/latest/download/app-debug.apk"
            className="inline-flex items-center px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors shadow-lg"
          >
            <SafeIcon icon={FaAndroid} className="text-3xl mr-3 text-green-500" />
            <div className="flex flex-col items-start">
              <span className="text-[10px] uppercase tracking-wider opacity-80 leading-none mb-1">Download APK</span>
              <span className="text-lg font-semibold leading-none">For Android</span>
            </div>
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default Landing;